import {useEffect, useState} from "react";
import {VIEW_TYPE} from '../../../../../enums/ViewType';

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */

export const TotalMealsApp = ({
                                  subViewChild,
                                  setCriteria,
                                  setFinalArray,
                                  setSearchElement
                              })=> {
    const [selectedDate, setSelectedDate] = useState(new Date());

    useEffect(() => {
        if(subViewChild === VIEW_TYPE.GRID.name){
            setCriteria([]);
            setFinalArray([]);
            setSearchElement("");
        }
    }, [subViewChild]);

    return {
        selectedDate,
        setSelectedDate
    }
}
